import config from '../config';

const psf = 'limit=:limit&page=:page&order_by=:sorting';
const targetGroupBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'branches' : 'classificationCodes';
const visitBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'company.classificationCodes.branches' : 'company.classificationCodes';
const companyBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'classificationCodes.branches' : 'classificationCodes';

export default {
  login: '/OAuthClients/token',
  passwordsRecoverer: '/guest/passwords/recoverer',
  currentUserData: '/current_user\\?includes=projects.modules,hubspotPermissions&limit=unlimited&appends=display_timezone,display_datetime_format',
  ping: '/ping',
  projects: '/projects\\?includes=modules&limit=unlimited',
  roles: '/roles',
  modules: '/modules',
  forgotPassword: '/guest/passwords/recoverer/request',

  leadScoringList: `/projects/:projectId/lead_scoring/profiles\\?${psf}&includes=related_to,hubspotTaskOwner`,
  leadScoringItem: '/projects/:projectId/lead_scoring/profiles/:id\\?includes=scoringAttributes,scoringAttributes.values,hubspotTaskOwner',
  leadScoringCreate: '/projects/:projectId/lead_scoring/profiles',
  leadScoringUpdate: '/projects/:projectId/lead_scoring/profiles/:id',
  leadScoringRemove: '/projects/:projectId/lead_scoring/profiles/:id',
  leadScoringTest: '/projects/:projectId/lead_scoring/filters?includes=:includes&limit=:limit?&order_by=:orderColumn,:orderDirection',

  leadContactPeopleList: '/lead_contacts/people_search',
  leadContactCompanyList: '/lead_contacts/organizations_search',

  pageGroupsList: '/projects/:projectId/page_groups\\?limit=unlimited',
  pageGroupsListPsf: `/projects/:projectId/page_groups\\?${psf}`,
  pageGroupsItem: '/projects/:projectId/page_groups/:id\\?includes=urlPatterns',
  pageGroupsCreate: '/projects/:projectId/page_groups',
  pageGroupsUpdate: '/projects/:projectId/page_groups/:id',
  pageGroupsRemove: '/projects/:projectId/page_groups/:id',

  categoryItem: '/target_group_categories/:id',
  categoriesList: '/target_group_categories\\?limit=unlimited',
  categoriesListFiltered: '/target_group_categories\\?limit=unlimited',
  categoriesListPaginated: `/target_group_categories\\?${psf}`,
  categoryCreate: '/target_group_categories',
  categoryUpdate: '/target_group_categories/:id',
  categoryRemove: '/target_group_categories/:id',

  countryRegionsList: '/country_groups\\?limit=unlimited',
  countryRegionsListPsf: `/country_groups?${psf}`,
  countryRegionsItem: '/country_groups/:id\\?includes=countries',
  countryRegionsCreate: '/country_groups',
  countryRegionsUpdate: '/country_groups/:id',
  countryRegionsRemove: '/country_groups/:id',
  usersListPaginated: `/users\\?includes=projects&${psf}`,
  usersList: '/users\\?limit=unlimited',
  usersListFiltered: '/users\\?limit=unlimited',
  userCreate: '/users',
  userUpdate: '/users/:id',
  userPasswordChange: '/users/:id/password',
  userAvatarCreate: '/users/:id/avatar',
  userRemove: '/users/:id',
  userGetInfo: '/users/:id\\?includes=projects',
  userProjectAssign: '/projects/:projectId/users/:userId',
  aiOutreachAgentsList: '/projects/:projectId/ai_outreach_agents\\?limit=unlimited',
  aiOutreachAgentsListPsf: `/projects/:projectId/ai_outreach_agents\\?${psf}`,
  aiOutreachAgentsTestPrompt: '/projects/:projectId/ai_outreach_agents/test_prompt',
  aiOutreachAgentsItem: '/projects/:projectId/ai_outreach_agents/:id',
  aiOutreachAgentsCreate: '/projects/:projectId/ai_outreach_agents',
  aiOutreachAgentsUpdate: '/projects/:projectId/ai_outreach_agents/:id',
  aiOutreachAgentsRemove: '/projects/:projectId/ai_outreach_agents/:id',
  branchesList: '/branches\\?includes=codes&limit=unlimited',
  branchesListFiltered: '/branches\\?limit=unlimited',
  branchesListPaginated: `/branches\\?includes=codes&${psf}`,
  branchGet: '/branches/:id\\?includes=translations,codes',
  branchCreate: '/branches',
  branchUpdate: '/branches/:id',
  branchRemove: '/branches/:id',
  branchReplace: '/branches/:id/replace_and_delete',
  countryGroupList: '/country_groups',
  countriesList: '/countries\\?limit=unlimited&order_by=name,asc',
  targetGroupsList: `/projects/:projectId/target_groups\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns&${psf}`,
  targetGroupsListFiltered: `/projects/:projectId/target_groups\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns`,
  targetGroupsListForBranch: '/target_groups\\?branch_id=:id',
  targetGroupCreate: '/projects/:projectId/target_groups',
  targetGroupGet: `/projects/:projectId/target_groups/:id\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns,leadMarks`,
  targetGroupUpdate: '/projects/:projectId/target_groups/:id',
  targetGroupDelete: '/projects/:projectId/target_groups/:id',
  targetGroupDuplicate: '/projects/:projectId/target_groups/:id/duplicates',
  kompassBranchesList: '/kompass/classification_codes\\?parent_id=:id\\&limit=unlimited',
  downloadBranchesList: '/kompass/classification_codes_exporter\\?version=:version&locale=:locale',
  classificationCodes2ndLevelSearchByLabel: '/kompass/classification_codes\\?level=2&label=:label',
  companiesList: `/projects/:projectId/companies\\?includes=hasHubspotTransferClaim,country,leadMarks,${companyBranchesInclude}&${psf}`,
  companiesAttributes: '/projects/:projectId/company_attributes\\?includes=leadMarks&limit=unlimited',
  companiesListPaginated: `/projects/:projectId/company_attributes\\?includes=leadMarks&${psf}`,
  companyDetail: '/projects/:projectId/company_attributes/:companyId\\?includes=leadMarks',
  companyCreate: '/projects/:projectId/company_attributes',
  companyUpdate: '/projects/:projectId/company_attributes/:companyId',
  companyDelete: '/projects/:projectId/company_attributes/:companyId',
  projectsList: '/projects\\?includes=users,modules&limit=unlimited',
  projectsListPaginated: `/projects\\?includes=users,modules&${psf}`,
  projectCreate: '/projects',
  projectUpdate: '/projects/:id',
  projectDetail: '/projects/:id',
  projectDelete: '/projects/:id',

  campaignsListFiltered: `/projects/:projectId/campaigns\\?${psf}`,
  campaignsList: '/projects/:projectId/campaigns',
  campaignItem: '/projects/:projectId/campaigns/:campaignId',
  campaignCreate: '/projects/:projectId/campaigns',
  campaignUpdate: '/projects/:projectId/campaigns/:campaignId',
  campaignRemove: '/projects/:projectId/campaigns/:campaignId',

  leadLabelsList: '/lead_marks\\?limit=unlimited',
  leadLabelsListFiltered: '/lead_marks\\?limit=unlimited',
  leadLabelsListPaginated: `/lead_marks\\?${psf}`,
  leadLabelsDetail: '/lead_marks/:id\\?includes=translations',
  leadLabelsCreate: '/lead_marks',
  leadLabelsUpdate: '/lead_marks/:id',
  leadLabelsDelete: '/lead_marks/:id',
  leadsVisitsListPaginated: `/projects/:projectId/companies\\?includes=country,${companyBranchesInclude}&${psf}`,
  leadVisitSessionRecording: '/projects/:projectId/recordings/:uuid',
  leadsProjectVisits: `/projects/:projectId/visits/\\?includes=hasHubspotTransferClaim,scoringProfile,privateScoringProfile,privateScore,finalScore,company.leadMarks,company.country,${visitBranchesInclude}&${psf}`,
  leadsVisits: '/projects/:projectId/companies/:companyId/visits\\?limit=:limit&skip=:skip&includes=scoringProfile,privateScoringProfile,privateScore,finalScore',
  leadsLeadDetails: `/projects/:projectId/companies/:leadId/\\?includes=country,leadMarks,${companyBranchesInclude},&appends=returned_visitor,last_referer,social_links`,
  toggleCompanyHidden: '/projects/:projectId/companies/:companyId/hidden',
  simpleLeadsLeadDetails: '/projects/:projectId/companies/:leadId',
  assignLeadMarks: '/projects/:projectId/companies/:leadId/lead_marks',
  startExportLeadCompanies: '/projects/:projectId/export/companies\\?order_by=:sorting',
  startExportLeadVisits: '/projects/:projectId/export/visits\\?order_by=:sorting',
  startImportCompanyAttributesLeadLabels: '/projects/:projectId/imports/company_attribute',

  downloadLeads: '/projects/:projectId/exports/:uuid',
  markISP: '/feature/company/:id/isp',

  matomoValidateSiteId: '/matomo_validator',
  matomoGetCompanyVisitDetails: '/projects/:projectId/companies/:companyId/visits/:visitId/\\?includes=target_group',

  generateToken: '/projects/:projectId/generate_api_token',
  updateHubspotToken: '/projects/:projectId/hubspot',
  tokenValidation: '/guest/passwords/tokens/validator',
};



// WEBPACK FOOTER //
// ./src/utils/urls.js